import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    topic: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});

class msListSigniantApp extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/download-signiant-app"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Download Signiant App" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/configure-signiant-app"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Configuring Signiant App" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/using-proxy-servers"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Working With Proxy Servers" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/debug-transfer-logs"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Collecting Debug Logs" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/troubleshooting-signiant-app-windows"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Troubleshooting (Windows)" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/troubleshooting-signiant-app-macos"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Troubleshooting (macOS)" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/transferring-without-signiant-app"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="App-less Transfers" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/media-shuttle/signiant-app/signiant-app-beta-program"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Beta Program" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

msListSigniantApp.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    handleDrawerToggle: PropTypes.func,
    onActive: PropTypes.func,
};

export default withStyles(styles)(msListSigniantApp);
